export default "__VITE_ASSET__CdBWoLZr__"